/* Hyperush — page order, home link, and the Know more disclosure. */
(function () {
  'use strict';

  /* How much of the first story image shows above the button while closed. */
  var PEEK_RATIO = 0.30;

  var COPY = {
    kickerClosed: 'Everything about it',
    kickerOpen:   'The full story',
    labelClosed:  'Know more',
    labelOpen:    'Show less',
    ctaClosed:    'More details',
    ctaOpen:      'Hide details',
    sub:          'Why this one · The point · The look · Specs'
  };

  var APERTURE =
    '<svg viewBox="0 0 48 48" class="hy-ap" aria-hidden="true">' +
      '<g class="hy-ap__blades">' +
        '<path d="M24 24 L24 6 L39.6 15 Z"/>' +
        '<path d="M24 24 L39.6 15 L39.6 33 Z"/>' +
        '<path d="M24 24 L39.6 33 L24 42 Z"/>' +
        '<path d="M24 24 L24 42 L8.4 33 Z"/>' +
        '<path d="M24 24 L8.4 33 L8.4 15 Z"/>' +
        '<path d="M24 24 L8.4 15 L24 6 Z"/>' +
      '</g>' +
      '<circle class="hy-ap__hole" cx="24" cy="24" r="4"/>' +
      '<circle class="hy-ap__ring" cx="24" cy="24" r="21"/>' +
    '</svg>';

  var HOME =
    '<svg viewBox="0 0 24 24" class="hy-home" aria-hidden="true">' +
      '<path class="hy-home__roof" d="M3 11.4 12 4.2l9 7.2"/>' +
      '<path class="hy-home__walls" d="M5.5 10.2v9.6h13V10.2"/>' +
      '<rect class="hy-home__door" x="9.9" y="13.7" width="4.2" height="6.1" rx="0.7"/>' +
    '</svg>';

  function run() {
    var main = document.querySelector('.content-for-layout');
    if (!main || main.querySelector('.hy-more')) return;

    var pick = function (key) { return main.querySelector('[id*="' + key + '"]'); };

    var product = pick('__main');
    var marquee = pick('hy_marquee');
    var reels   = pick('hy_reels');
    var hl      = pick('hy_highlights');
    var story   = pick('hy_story');
    var specs   = pick('hy_specs');
    var trust   = pick('hy_trust');
    var faq     = pick('hy_faq');

    if (!hl || !story || !specs) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var back = document.createElement('nav');
    back.className = 'hy-back';
    back.setAttribute('aria-label', 'Breadcrumb');
    back.innerHTML =
      '<a class="hy-back__link" href="' + root + '" aria-label="Back to home" title="Home">' + HOME + '</a>';

    var wrap = document.createElement('section');
    wrap.className = 'hy-more';
    wrap.innerHTML =
      '<div class="hy-more__head">' +
        '<span class="hy-more__kicker">' + COPY.kickerClosed + '</span>' +
        '<h2 class="hy-more__label">' + COPY.labelClosed + '</h2>' +
        '<span class="hy-more__sub">' + COPY.sub + '</span>' +
      '</div>' +
      '<div class="hy-more__panel">' +
        '<div class="hy-more__inner"></div>' +
        '<div class="hy-more__fade" aria-hidden="true"></div>' +
      '</div>' +
      '<div class="hy-more__foot">' +
        '<button class="hy-more__cta" type="button" aria-expanded="false">' +
          '<span class="hy-more__ic">' + APERTURE + '</span>' +
          '<span class="hy-more__ctatext">' + COPY.ctaClosed + '</span>' +
          '<span class="hy-more__arrow" aria-hidden="true">' +
            '<svg viewBox="0 0 16 16"><path d="M8 2v11M3 8.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="square"/></svg>' +
          '</span>' +
        '</button>' +
      '</div>';

    var inner = wrap.querySelector('.hy-more__inner');
    inner.appendChild(hl);
    inner.appendChild(story);
    inner.appendChild(specs);

    [back, product, marquee, wrap, trust, reels, faq].forEach(function (n) {
      if (n) main.appendChild(n);
    });

    var btn = wrap.querySelector('.hy-more__cta');
    var panel = wrap.querySelector('.hy-more__panel');
    panel.id = 'hy-more-panel';
    btn.setAttribute('aria-controls', panel.id);

    var timer = null;

    /* The closed height is driven by a custom property rather than an inline
       max-height. The stylesheet rule carries !important (it has to beat
       hyperush-layout.css), and an !important declaration outranks an inline
       style — so setting panel.style.maxHeight did nothing and the panel stayed
       clamped even when open. Changing the variable moves the resolved value
       instead, which both wins the cascade and still animates, because
       max-height is transitioned. */
    function setMax(value) {
      wrap.style.setProperty('--hy-more-max', value);
    }

    /* Closed height = everything above the first story image, plus PEEK_RATIO
       of that image. Measured live so it holds at any screen width. */
    function peekValue() {
      var media = inner.querySelector('.hy-story__img, .hy-story__ph');
      if (!media) return '760px';
      var innerTop = inner.getBoundingClientRect().top;
      var box = media.getBoundingClientRect();
      if (!box.height) return '760px';
      return Math.round((box.top - innerTop) + box.height * PEEK_RATIO) + 'px';
    }

    function measure() {
      if (!wrap.classList.contains('is-open')) setMax(peekValue());
    }

    function setOpen(open) {
      window.clearTimeout(timer);
      wrap.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      wrap.querySelector('.hy-more__ctatext').textContent = open ? COPY.ctaOpen : COPY.ctaClosed;
      wrap.querySelector('.hy-more__label').textContent = open ? COPY.labelOpen : COPY.labelClosed;
      wrap.querySelector('.hy-more__kicker').textContent = open ? COPY.kickerOpen : COPY.kickerClosed;

      var full = inner.scrollHeight;

      if (open) {
        setMax(full + 'px');
        timer = window.setTimeout(function () {
          if (wrap.classList.contains('is-open')) setMax('none');
        }, 620);
      } else {
        setMax(full + 'px');
        void panel.offsetHeight;
        setMax(peekValue());
        wrap.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }

    btn.addEventListener('click', function () {
      setOpen(!wrap.classList.contains('is-open'));
    });

    /* Re-measure as the story image actually lands and on resize. */
    measure();
    window.addEventListener('load', measure);

    var firstImg = inner.querySelector('.hy-story__img');
    if (firstImg && !firstImg.complete) firstImg.addEventListener('load', measure);

    var rt = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(measure, 150);
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(measure).observe(inner);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
